import { useMutation } from '@tanstack/react-query';

import { deleteListOneOpenPendingTicketApi } from '../api';

export default function useDeleteListOneOpenPendingTicketMutation(
  options?: any
) {
  return useMutation(deleteListOneOpenPendingTicketApi, options);
}
